import { render, staticRenderFns } from "./inviteSetting.vue?vue&type=template&id=65116f3b&scoped=true&"
import script from "./inviteSetting.vue?vue&type=script&lang=js&"
export * from "./inviteSetting.vue?vue&type=script&lang=js&"
import style0 from "./inviteSetting.vue?vue&type=style&index=0&id=65116f3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65116f3b",
  null
  
)

export default component.exports